export const locale = {
    lang: 'nl',
    data: {
        'PLANNINGSIMPEL': {
            'TITEL': 'Planning',
            'FILTERTEXT': 'Filter op text'
        },
    }
};
